import { useMemo } from 'react';

const imageSrcBuilder = (host = 'images.gasbuddy.io') => ({ height, url, width } = {}) => url && `https://${host}/${width || 'auto'}x${height || 'auto'}/${url}`;

export default function useImageSrcBuilder(imagesHost) {
  return useMemo(() => imageSrcBuilder(imagesHost), [imagesHost]);
}
